import React from 'react';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';
import { Row } from '../../Resources';
import ActivitiesRegistrationHeader from 'components/ActivitiesRegistrationDetails/ActivitiesRegistrationHeader';

export default function SchedulingUpdate({ activityData, lastRegister, newRegister }) {
  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader
          activityData={activityData}
        />
        <Grid container style={{ marginTop: 10 }}>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Agendamento Anterior</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(lastRegister).includes('startDateTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Data início</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {moment(lastRegister?.startDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('endDateTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Data fim</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {moment(lastRegister?.endDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('completeAddress') && (
                <Row>
                  <Typography color='primary'>
                    <b>Endereço</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {lastRegister?.completeAddress || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('plate') && (
                <Row>
                  <Typography color='primary'>
                    <b>Placa</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {lastRegister?.plate || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('situationId') && (
                <Row>
                  <Typography color='primary'>
                    <b>Situação</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+lastRegister?.situationId == 1 && 'Não confirmado'}
                    {+lastRegister?.situationId == 2 && 'Confirmado'}
                  </Typography>
                </Row>
              )}
            </Grid>
          </Grid>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginTop: 10, marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Agendamento Atual</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(newRegister).includes('startDateTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Data início</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {moment(newRegister?.startDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('endDateTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Data fim</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {moment(newRegister?.endDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('completeAddress') && (
                <Row>
                  <Typography color='primary'>
                    <b>Endereço</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {newRegister?.completeAddress || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('plate') && (
                <Row>
                  <Typography color='primary'>
                    <b>Placa</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {newRegister?.plate || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('situationId') && (
                <Row>
                  <Typography color='primary'>
                    <b>Situação</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {+newRegister?.situationId == 1 && 'Não confirmado'}
                    {+newRegister?.situationId == 2 && 'Confirmado'}
                  </Typography>
                </Row>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}